const professionDetail = [
  "Lastras (90x180 ou superior)",
  "Pedras/ Concreto Arquitetônico",
  "Porcelanataria (nicho/bancadas/outros)",
  "Porcelanato pequeno formatos - 60x60 ou menor",
  "Porcelanato médio formatos - acima de 60x60 até 90x90",
  "Porcelanato grandes formatos - 90x90 ou superior",
  "Ultracompacto",
];

export default professionDetail;
